import {customAxios, PROFORMA_URL} from '../constants';
import {FETCH_MAESTROS} from './types';
import { evalAction, serverError } from '../utils/actionError';

export function fetchMaestro(codigo, descripcion) {

    const config = {
        headers: {
            idUsuario: "910",
            "numPag": "1",
            "cantiRegPag": "999",
        }
    };

    const data = {
        codGrupo: codigo,
        descripcion: descripcion,
        indInactivo:false
    };

    const request = customAxios.post(`${PROFORMA_URL}/mantenimiento/tablaMaestro/listar`, data, config)
    .then(({ data }) => evalAction(data, 'listar'))
    .catch(error => serverError(error, 'listar'))

    return {
        type: FETCH_MAESTROS,
        payload: request,
    };
}



// WEBPACK FOOTER //
// ./src/actions/MantMaestro.js